{
  "alert.informative": "Informative",
  "alert.negative": "Negative",
  "alert.notice": "Notice",
  "alert.positive": "Positive",
  "chat.newMessage": "Ny besked",
  "chat.scrollToBottom": "Scroll ned til bunden",
  "messagefeedback.thumbDown": "Dårligt svar",
  "messagefeedback.thumbUp": "Godt svar",
  "promptfield.aiDisclaimer": "Svar genereres med AI og kan være unøjagtige. Tjek før brug.",
  "promptfield.aiUserGuidlines": "AI-brugerretningslinjer",
  "promptfield.attachments": "Vedhæftninger",
  "promptfield.insertButton": "Tilføj",
  "promptfield.label": "Prompt",
  "promptfield.placeholder": "Er du klar til at komme i gang? Stil et spørgsmål, del en idé, eller tilføj en opgave.",
  "promptfield.placeholder.small": "Ask anything",
  "promptfield.stopButton": "Stop",
  "promptfield.submitButton": "Send",
  "promptfield.uploading": "Upload",
  "responsestatus.loading": "Indlæser",
  "responsestatus.processing": "Processing...",
  "voicebutton.startListening": "Start optagelsen",
  "voicebutton.stopListening": "Stop optagelsen",
  "attachmentlist.previousAttachments": "Show previous attachments",
  "attachmentlist.nextAttachments": "Show next attachments"
}
